import React from "react";

//export const { Provider, Consumer } = React.createContext({
const UserContext = React.createContext({
  dataLake: {
    user: 'Unauthenticated',
    role: 'None'
  },
  selectedClient: null,
  clients: {}
});

export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;
export default UserContext;

// export default function UserContext(props) {
//   const { value } = props;
 
//   return (
//     <UserContext.Provider value={value}>
//       {props.children}
//     </UserContext.Provider>
//   );
// }

